export default __webpack_public_path__ + "static/media/img7.039aadd4.png";